import { createSlice } from '@reduxjs/toolkit'

const initialState = {
  fields: {
    consent: false,
  },
  errors: {},
}

const loginSlice = createSlice({
  name: 'loginSlice',
  initialState,
  reducers: {
    setFields: (state, action) => {
      state.fields = { ...state.fields, ...action.payload }
    },
    clearFields: (state) => {
      state.fields = { consent: false }
    },
    deleteFields: (state, action) => {
      const fields = { ...state.fields }
      action.payload.forEach((key) => {
        delete fields[key]
      })

      state.fields = fields
    },
    setErrors: (state, action) => {
      state.errors = action.payload
    },
    setLegalConfigs: (state, action) => {
      state.legalConfigs = action.payload
    },
  },
})

export default loginSlice.reducer

export const { setFields, deleteFields, setErrors, setLegalConfigs, clearFields } = loginSlice.actions
